import { ScopeHierarchy, ScopeHierarchyNode } from "../Scopes.types";

export const getScopeDisplayName = (scopeType: string, scopeHierarchy: ScopeHierarchy) =>
    getScopeTypeDisplayNameGivenNode(scopeHierarchy.Root, scopeType) ?? scopeType;

export const getScopeTypeDisplayNameGivenNode = (rootNode: ScopeHierarchyNode, scopeType: string) => {
    const bfsQueue = [rootNode];
    while (bfsQueue.length) {
        const node = bfsQueue.shift();
        if (node?.ScopeType === scopeType) {
            return node.DisplayName;
        }
        (node?.ChildScopes || []).forEach((child) => {
            bfsQueue.push(child);
        });
    }
    return undefined;
};
